import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Box, Typography, IconButton, Card, CardContent, Grid, Radio, List, ListItem, ListItemButton,
    ListItemText, ListItemIcon, Avatar, Slider, TextField, Button, ListItemAvatar,
    Checkbox, Chip, Alert, Tooltip,
    CardActions,
    CircularProgress,
    TablePagination,
    Tab,
    Tabs,
    InputAdornment,
    MenuItem,
    FormControl,
    Select,
    styled
} from "@mui/material";
import {
    Lock,
    Star,
    Info,
    MusicNote,
    Toll,
    Search,
    FilterList,
    Add,
    Schedule
} from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import useSnackDispatcher from '../../_helpers/reusablefunctions/snackBarComponent';
import { handleSongList } from '../../_services/creater/creatorSongList.service';
import imgThumbnail from '../../img/thumbnail.png'
import ArtistCampaign from "./artistCampaign";
import BudgetPlan from "./budgetPlan";
import { useHistory, useLocation } from "react-router-dom";
import ApiService from "../../_services/ApiService";
import CampaignHeader from './campaignHeader'
import useHandleRazorPayment from "./paymentRazorpay";
import { getStrPlatformImg } from "../../_helpers/reusablefunctions/getStreamingPlatform";
import PageNotFound from "../../admin/PageNotFound";
import { SkeletonWaveCard } from "../../_helpers/reusablefunctions/SkeletonCard";
import NoResults from "../../components/reusableComponents/NoResults";
import { submitDemo } from "../../_services/creater/creatorDemo.service";
import { useParams } from "react-router-dom";
import { genreMoodLanguage } from "../../components/reusableComponents/genreMoodLanguage";
import dayjs from "dayjs";


const SubTabs = styled(Tabs)(({ theme }) => ({
    minHeight: 36,
    '& .MuiTabs-indicator': {
        height: 3,
        borderRadius: 2,
        backgroundColor: '#ED1C24',
    },
}));

const SubTab = styled(Tab)(({ theme }) => ({
    textTransform: 'none',
    minHeight: 36,
    minWidth: 0,
    padding: '6px 16px',
    fontWeight: 500,
    fontSize: 14,
    '&.Mui-selected': {
        color: "#ED1C24",
    },
}));

export default function PromotionCampaign() {
    const { successSnack, errorSnack } = useSnackDispatcher();
    const history = useHistory();
    const location = useLocation();
    const { type, subType } = useParams();

    const getInitialStep = () => {
        if (subType) return 2;
        if (type) return 1;
        return 0;
    };

    const getInitialCampaignType = () => {
        if (type === 'artist') return 'promotion';
        if (type === 'creator') return 'reelcampaign';
        return location.state?.campaignDetail?.id ? 'reelcampaign' : null;
    };

    const [activeStep, setActiveStep] = useState(getInitialStep());
    const [promotionData, setPromotionData] = useState([]);
    const [songList, setSongList] = useState([]);
    const [songsList, setSongsList] = useState([]);
    const [campaignType, setCampaignType] = useState(getInitialCampaignType());
    const [selectedPlatform, setSelectedPlatform] = useState(location.state?.campaignDetail?.platform?.platformId || []);
    const [nextDisable, setNextDisable] = useState(true);
    const [stremingPlatform, setStremingPlatform] = useState([]);
    const [stremingPlatformLoader, setStremingPlatformLoader] = useState(true);
    const [songId, setSongId] = useState(location.state?.campaignDetail?.song || '');
    const [activePlan, setActivePlan] = useState(null)
    const [packageAmount, setPackageAmount] = useState(null);
    const [formValues, setFormValues] = useState({
        selectedGenres: '', selectedMood: '', selectedLanguage: '', campaignName: '',
        taggetAccount: '', suggHashtag: '', specialNote: '', selectedCampaignPlatform: [],
        startDate: '', endDate: '', budget: '', currency: '', targetReelsCount: '', targetStoryCount: '', targetShortsCount: '', targetPostsCount: '', InstagramAudioLink: ''
    });
    const [formDateValues, setFormDateValues] = useState({ startDate: '', endDate: '', releaseDate: '' });
    const streamingPlatform = useSelector((state) => state.streamingPlatform.streamingPlatform);
    const userData = useSelector((state) => state.userData.userData);
    const [activeBtnText, setActiveBtnText] = useState('Next');
    const handlePayment = useHandleRazorPayment();
    const [creditLedgerData, setCreditLedgerData] = useState(null);
    const [loading, setLoading] = useState({ ledger: true });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [demoList, setDemoList] = useState([]);
    const [demoPage, setDemoPage] = useState(0);
    const [demoLimit, setDemoLimit] = useState(5);
    const [demoTotal, setDemoTotal] = useState(0);
    const [demoLoading, setDemoLoading] = useState(false);
    const [musicPage, setMusicPage] = useState(0);
    const [musicLimit, setMusicLimit] = useState(5);
    const [musicTotal, setMusicTotal] = useState(songList.length);
    const [musicsPage, setMusicsPage] = useState(0);
    const [musicsLimit, setMusicsLimit] = useState(5);
    const [musicsTotal, setMusicsTotal] = useState(songsList.length);
    const [selectedDemo, setSelectedDemo] = useState(null);
    const [songDuration, setSongDuration] = useState(selectedDemo?.song_duration || songId?.song_duration || '');
    const [clips, setClips] = useState(selectedDemo?.clips || songId?.clips || []);
    const [budgetError, setBudgetError] = useState('');
    const [hasInvalidReferenceLink, setHasInvalidReferenceLink] = useState(false);
    const [hasInvalidClipTime, setHasInvalidClipTime] = useState(false);
    const [currencyList, setCurrencyList] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [genreList, setGenreList] = useState([]);
    const [songGenreFilter, setSongGenreFilter] = useState("all");
    const [demoGenreFilter, setDemoGenreFilter] = useState("all");

    const [songSearch, setSongSearch] = useState("");
    const [demoSearch, setDemoSearch] = useState("");

    const [songSort, setSongSort] = useState("all");
    const [demoSort, setDemoSort] = useState("all");


    useEffect(() => {
        const { getGenreList } = genreMoodLanguage();

        getGenreList()
            .then((res) => {
                if (Array.isArray(res)) {
                    setGenreList(res);
                }
            })
            .catch(() => console.error("Failed to fetch Genre list"));
    }, []);


    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    useEffect(() => {
        ApiService.get("currency").then((res) => {
            if (res.status === 200 || res.status === 201) {
                { console.debug("Currency List:", res.data.data); }
                setCurrencyList(res.data?.data || []);
            }
        }).catch(() => errorSnack("Failed to fetch currency"))
    }, []);


    const fetchDemoList = async (page = 0, limit = demoLimit) => {
        if (!userData?.id) return;
        setDemoLoading(true);

        try {
            const offset = page;

            const response = await submitDemo(
                {
                    userId: userData.id, search_query: demoSearch,
                    genre: demoGenreFilter !== "all" ? demoGenreFilter : "",
                    filter:
                        demoSort === "newest" ? "newest" :
                            demoSort === "oldest" ? "oldest" :
                                demoSort === "a-z" ? "a_to_z" :
                                    demoSort === "z-a" ? "z_to_a" : "",
                },
                'GET',
                null,
                limit,
                offset,
            );

            if (response?.status === 200) {
                const data = response.data;
                setDemoList(data.results || []);

                const total =
                    data.total_count ??
                    data.count ??
                    (Array.isArray(data.results) ? data.results.length : 0);

                setDemoTotal(total);
                setDemoPage(page);
                setDemoLimit(limit);
            }
        } catch (err) {
            console.error(err);
            errorSnack("Failed to fetch demo list");
        } finally {
            setDemoLoading(false);
        }
    };

    useEffect(() => {
        if (userData?.id) {
            fetchDemoList(0, demoLimit);
        }
    }, [userData, demoSearch, demoGenreFilter, demoSort]);

    useEffect(() => {
        if (userData?.id) {
            ApiService.get("creditLedger", { user_id: userData.id }).then((creditLedgerRes) => {
                console.debug(creditLedgerRes);
                if (creditLedgerRes.status === 200 || creditLedgerRes.status === 201) {
                    setCreditLedgerData(creditLedgerRes.data);
                }
            }).catch((error) => {
                console.debug(error);
                errorSnack("Failed to fetch credit ledger data");
            }).finally(() => {
                setLoading({ ledger: false });
            });
        }
    }, [userData]);

    const [initialState, setInitialState] = useState({});

    useEffect(() => {
        setInitialState({
            campaignType, songId, selectedPlatform,
            formValues, formDateValues, packageAmount, activePlan
        });
    }, []);

    const hasUnsavedChanges = () =>
        JSON.stringify({
            campaignType, songId, selectedPlatform,
            formValues, formDateValues, packageAmount, activePlan
        }) !== JSON.stringify(initialState);

    const handleBeforeUnload = (event) => {
        const confirmationMessage = "Are you sure you want to leave? Changes you made may not be saved.";
        event.preventDefault();
        event.returnValue = confirmationMessage;
        return confirmationMessage;
    };

    useEffect(() => () => window.removeEventListener("beforeunload", handleBeforeUnload), []);

    useEffect(() => { if (userData?.id) fetchUserSongs(); }, [userData]);

    useEffect(() => {
        let disable = true;

        if (campaignType === 'promotion') {
            if (activeStep === 0) disable = !campaignType;
            else if (activeStep === 1) disable = !(songId?.id || selectedDemo?.id);
            else if (activeStep === 2) disable = !selectedPlatform;
            else if (activeStep === 3) disable = false;
        } else if (campaignType === 'reelcampaign') {
            if (activeStep === 0) disable = !campaignType;
            else if (activeStep === 1) disable = !(songId?.id || selectedDemo?.id);
            else if (activeStep === 2) {
                const isDemo = !!selectedDemo?.id;
                const isSong = !!songId?.id;

                const genreValue = isDemo ? selectedDemo?.genre?.id : (isSong ? songId?.genre?.id : formValues.selectedGenres);
                const moodValue = isDemo ? selectedDemo?.mood?.id : (isSong ? songId?.mood?.id : formValues.selectedMood);
                const languageValue = isDemo ? selectedDemo?.language?.id : (isSong ? songId?.language?.id : formValues.selectedLanguage);

                const isBudgetValid =
                    formValues?.budget &&
                    Number(formValues.budget) >= 125000 &&
                    formValues?.currency;
                const hasInvalidDateRange = Boolean(
                    formDateValues.startDate &&
                    formDateValues.endDate &&
                    dayjs(formDateValues.endDate).isBefore(dayjs(formDateValues.startDate), 'day')
                );

                disable = !(
                    formValues.campaignName &&
                    genreValue &&
                    moodValue &&
                    languageValue &&
                    formValues.selectedCampaignPlatform.length &&
                    formDateValues.startDate &&
                    formDateValues.endDate &&
                    !hasInvalidDateRange &&
                    songDuration &&
                    clips.length > 0 &&
                    clips[0].start_time &&
                    clips[0].end_time &&
                    isBudgetValid &&
                    !hasInvalidReferenceLink &&
                    !hasInvalidClipTime
                );
            }
            else if (activeStep === 3) disable = !(packageAmount && activePlan);
        }

        setNextDisable(disable);
    }, [
        campaignType, activeStep, songId, selectedDemo, selectedPlatform,
        formValues, formDateValues, packageAmount, activePlan, songDuration, clips
    ]);

    useEffect(() => {
        if (selectedDemo) {
            setFormValues({
                selectedGenres: selectedDemo?.genre?.id || '',
                selectedMood: selectedDemo?.mood?.id || '',
                selectedLanguage: selectedDemo?.language?.id || '',
                campaignName: '',
                taggetAccount: '',
                suggHashtag: '',
                specialNote: '',
                selectedCampaignPlatform: [],
                startDate: '',
                endDate: ''
            });
            setSongDuration(selectedDemo?.song_duration || '');
            setClips(selectedDemo?.clips || [{ start_time: '', end_time: '' }]);
        } else if (songId) {
            setFormValues({
                selectedGenres: songId?.genre?.id || '',
                selectedMood: songId?.mood?.id || '',
                selectedLanguage: songId?.language?.id || '',
                campaignName: '',
                taggetAccount: '',
                suggHashtag: '',
                specialNote: '',
                selectedCampaignPlatform: [],
                startDate: '',
                endDate: ''
            });
            setSongDuration(songId?.song_duration || '');
            setClips(songId?.clips || [{ start_time: '', end_time: '' }]);

            setStremingPlatformLoader(true);
            ApiService.get('getrelatedStreamingPlatforms', {
                search: songId?.id,
                user_id: songId?.userId
            }).then((res) => {
                if (res.status == 200 || res.status == 201) {
                    setStremingPlatform(res?.data?.data);
                }
            }).catch((error) => {
                console.debug(error);
            }).finally(() => setStremingPlatformLoader(false));
        }
    }, [songId, selectedDemo]);

    useEffect(() => {
        if (clips.length === 0) {
            setClips([{ start_time: '', end_time: '' }]);
        }
    }, [clips]);

    const fetchUserSongs = (page = 0, limit = musicLimit) => {
        const offset = page;

        handleSongList({ userId: userData.id }, "GETBYUSER", limit, offset)
            .then((response) => {
                console.log("Songs API response:", response);

                if (response?.status === 200) {
                    setSongList(response.data.results || []);
                    setMusicTotal(response.data.count ?? response.data.results.length);

                    setMusicPage(page);
                    setMusicLimit(limit);
                } else {
                    errorSnack("Failed to fetch songs");
                }
            })
            .catch((err) => {
                console.error("Failed to fetch songs:", err);
                errorSnack("Failed to fetch songs");
            });
    };

    const fetchUserSong = async (page = 0, limit = musicLimit) => {
        if (!userData?.id) return;

        setDemoLoading(true);
        const offset = page * limit;

        try {
            const res = await ApiService.get("getSongList", {
                search: userData.id,
                limit,
                offset,
                search_query: songSearch || "",
                genre: songGenreFilter !== "all" ? songGenreFilter : "",
                filter:
                    songSort === "newest" ? "newest" :
                        songSort === "oldest" ? "oldest" :
                            songSort === "a-z" ? "a_to_z" :
                                songSort === "z-a" ? "z_to_a" : "",
            });

            if (res?.status === 200) {
                const data = res.data;
                console.log("Fetched Songs:", data);

                setSongsList(data?.results || []);
                setMusicsTotal(data?.total_count ?? data?.count ?? data?.results?.length ?? 0);

                setMusicsPage(page);
                setMusicsLimit(limit);
            } else {
                errorSnack("Failed to fetch songs");
            }
        } catch (err) {
            console.error("Song Fetch Error:", err);
            errorSnack("Failed to fetch songs");
        } finally {
            setDemoLoading(false);
        }
    };

    useEffect(() => {
        if (userData?.id) fetchUserSong(0, musicLimit);
    }, [userData, songSearch, songGenreFilter, songSort]);

    async function artistcampaignpromotion() {
        setIsSubmitting(true);

        try {
            if (!formValues?.budget) {
                errorSnack("Budget is required");
                setIsSubmitting(false);
                return;
            }

            if (Number(formValues.budget) < 125000) {
                errorSnack("Budget must be at least ₹125,000");
                setIsSubmitting(false);
                return;
            }

            if (!clips?.length || !clips[0]?.start_time || !clips[0]?.end_time) {
                errorSnack("At least one clip with start & end time is required");
                setIsSubmitting(false);
                return;
            }

            const status =
                campaignType === "reelcampaign"
                    ? selectedDemo?.id
                        ? "upcoming"
                        : songId?.id
                            ? "new"
                            : undefined
                    : undefined;

            if (campaignType === "promotion" && activeStep !== 0) {
                if (!songId?.id && !selectedDemo?.id) return;

                const promotionPayload = {
                    ...(songId?.id && { song: songId.id }),
                    ...(selectedDemo?.id && { demo: selectedDemo.id }),
                    platforms: selectedPlatform.join(','),
                    promotion: true,
                };

                const res = await ApiService.post('songPromotion', promotionPayload);

                if (res.status === 200 || res.status === 201) {
                    setPromotionData(res?.data?.data[0]?.fields);
                    successSnack("Artist campaign created successfully!");
                    history.push('/campaign');
                }
            } else {
                const reelCampaignPayload = {
                    ...(songId?.id && { song: songId.id }),
                    ...(selectedDemo?.id && { demo: selectedDemo.id }),
                    campaignName: formValues?.campaignName || '',
                    genre: formValues?.selectedGenres || '',
                    mood: formValues?.selectedMood || '',
                    language: formValues?.selectedLanguage || '',
                    platform: formValues?.selectedCampaignPlatform?.join(',') || '',
                    startDate: formDateValues?.startDate || '',
                    endDate: formDateValues?.endDate || '',
                    release_date: formDateValues?.releaseDate,
                    artistAccountsTag: formValues?.taggetAccount || '',
                    suggestedHastag: formValues?.suggHashtag || '',
                    notes: formValues?.specialNote || '',
                    packages: activePlan,
                    song_duration: songDuration || '',
                    clips: clips || [],
                    budget: formValues?.budget ? Number(formValues.budget) : '',
                    currency: formValues?.currency,
                    // currency: 1,
                    targetReelsCount: formValues?.targetReelsCount,
                    targetStoryCount: formValues?.targetStoryCount,
                    targetShortsCount: formValues?.targetShortsCount,
                    targetPostsCount: formValues?.targetPostsCount,
                    InstagramAudioLink: formValues?.InstagramAudioLink,
                    ...(status && { status })
                };

                Object.keys(reelCampaignPayload).forEach(key => {
                    if (reelCampaignPayload[key] === '' ||
                        reelCampaignPayload[key] === null ||
                        reelCampaignPayload[key] === undefined ||
                        (Array.isArray(reelCampaignPayload[key]) && reelCampaignPayload[key].length === 0)) {
                        delete reelCampaignPayload[key];
                    }
                });

                console.log('📤 Sending JSON payload:', reelCampaignPayload);

                const res = await ApiService.post('reelCampaign', reelCampaignPayload);

                if (res.status === 200 || res.status === 201) {
                    const newFields = res?.data?.fields;
                    setPromotionData(newFields);

                    history.push('/campaign');

                    // await handlePayment({
                    //     packageAmount,
                    //     songId: songId || selectedDemo,
                    //     promotionData: newFields
                    // });
                }
            }
        } catch (e) {
            console.error('❌ API Error:', e);
            errorSnack(e?.response?.data?.message || "Something went wrong");
        } finally {
            setIsSubmitting(false);
        }
    }

    const handleCampaignSelection = (type) => {
        setCampaignType(type);
        setNextDisable(false);
    };

    const handleSongSelection = (song) => {
        setSongId(song);
        setSelectedDemo(null);
        setNextDisable(false);
    };

    const handleDemoSelection = (demo) => {
        setSelectedDemo(demo);
        setSongId(null);
        setNextDisable(false);
    };

    const handleNext = async () => {
        if (campaignType === 'promotion') {
            if (activeStep === 0) {
                history.replace('/campaign/create/artist');
            }
            else if (activeStep === 1) {
                history.replace('/campaign/create/artist/released');
            }

            if (activeStep === 2) setActiveBtnText('Finish');
            if (activeStep === 3) {
                await artistcampaignpromotion();
                return;
            }
        }

        if (campaignType === 'reelcampaign') {
            if (activeStep === 0) {
                history.replace('/campaign/create/creator');
            }
            else if (activeStep === 1) {
                if (selectedDemo?.id) {
                    history.replace('/campaign/create/creator/unreleased');
                } else if (songId?.id) {
                    history.replace('/campaign/create/creator/released');
                }
            }

            if (activeStep === 2) setActiveBtnText('Payment');
            if (activeStep === 3) {
                await artistcampaignpromotion();
                return;
            }
        }

        setActiveStep((prev) => prev + 1);
    };

    const handlePrevious = () => {
        const newStep = activeStep - 1;

        if (newStep === 0) {
            history.replace('/campaign/create');
        } else if (campaignType === 'promotion') {
            if (newStep === 1) {
                history.replace('/campaign/create/artist');
            } else if (newStep === 2) {
                history.replace('/campaign/create/artist/released');
            }
        } else if (campaignType === 'reelcampaign') {
            if (newStep === 1) {
                history.replace('/campaign/create/creator');
            } else if (newStep === 2) {
                if (selectedDemo?.id) {
                    history.replace('/campaign/create/creator/unreleased');
                } else if (songId?.id) {
                    history.replace('/campaign/create/creator/released');
                }
            }
        }

        setActiveStep(newStep);
        setActiveBtnText('Next');
    };

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormValues(prev => ({ ...prev, [name]: value }));
    };

    const releaseDateChangeHandler = (newValue, pickerType) => {
        const isValidDate = newValue && dayjs(newValue).isValid();
        setFormDateValues(prev => ({ ...prev, [pickerType]: isValidDate ? dayjs(newValue).format('YYYY-MM-DD') : '' }));
    };

    const campaignData = [
        {
            type: "promotion",
            text: "Artist Community Campaign",
            tooltipText: " Every artist needs a space where they're truly heard — not judged by bots or fake numbers. With the Artist Community Campaign, your music reaches real musicians who get you.  They listen, feel, and give  honest feedback that helps you grow. It's more than promotion — it's a journey of becoming better, together.  Join the movement where artists lift each other up.",
            subText: 'For emerging artists to get organic support through our community.'
        },
        {
            type: "reelcampaign",
            text: "Creator Campaign",
            tooltipText: " Every great song deserves its moment. If you've just released a new track, now's your chance to make it explode. With our Song Reel Campaign, we put your song in the hands of real influencers, and creators who move culture. No bots, no shortcuts — just trusted promotion that's worked for 100+ artists and labels. From organic growth to  trending on Instagram sounds, this is your moment.  Let's make it count.",
            subText: 'For paid promotion through top creators and influencers.'
        }
    ];

    const reviewList = useMemo(() => [
        { id: 1, img: songId?.songPoster_url ? songId?.songPoster_url : songId?.cover_image ? `${process.env.REACT_APP_SONGAPIURL_MEDIA}${songId.cover_image}` : imgThumbnail, name: songId?.songTitle, label: songId?.artists },
        { id: 4, img: '', name: 'Note', label: `Use ${creditLedgerData?.total_balance} coins to start. We deduct ${creditLedgerData?.points_required_for_campaign} per campaign—valid for 15 days. Reapply later to stay listed.` },
    ], [songId]);

    const handleCheckboxChange = (event, platformKey) => {
        const isChecked = event.target.checked;
        setNextDisable(false);

        setSelectedPlatform(prev =>
            isChecked
                ? [...prev, platformKey]
                : prev.filter(item => item !== platformKey)
        );
    };

    const renderStepContent = () => {
        switch (activeStep) {
            case 0:
                return (
                    <Box maxWidth="lg" mx="auto">
                        <Box textAlign="right" mb={2}>
                            <Chip
                                label={`Your Coins: ${creditLedgerData?.total_balance || 0}`}
                                sx={{
                                    bgcolor: 'white',
                                    px: 2,
                                    py: 2,
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    boxShadow: 2
                                }}
                            />
                        </Box>

                        <Grid container spacing={3}>
                            {!loading.ledger ? campaignData.map((data, index) => {
                                const isDisabled = index === 0 && creditLedgerData?.total_balance < creditLedgerData?.points_required_for_campaign;
                                const isSelected = campaignType === data.type;

                                return (
                                    <Grid item xs={12} sm={6} md={6} key={data.type}>
                                        <Card
                                            key={data.type}
                                            sx={{
                                                width: '100%',
                                                height: '100%',
                                                // flex: { xs: '1 1 auto', sm: '0 1 48%' },
                                                // position: 'relative',
                                                borderRadius: 3,
                                                border: isSelected ? '2px solid #F14950' : '2px solid transparent',
                                                transition: 'all 0.3s ease',
                                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                opacity: isDisabled ? 0.6 : 1,
                                                padding: 2,
                                                paddingTop: 4,
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (!isDisabled) {
                                                    handleCampaignSelection(data.type);
                                                }
                                            }}
                                        >


                                            <CardContent sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', padding: '0px !important' }}>
                                                <Box>
                                                    <Avatar sx={{
                                                        width: 64,
                                                        height: 64,
                                                        bgcolor: isDisabled
                                                            ? 'grey.100'
                                                            : index === 0
                                                                ? '#dbeafe'
                                                                : '#fce7f3',
                                                        color: isDisabled
                                                            ? 'grey.400'
                                                            : index === 0
                                                                ? '#3b82f6'
                                                                : '#F14950'
                                                    }}>
                                                        {isDisabled ? (
                                                            <Lock fontSize="large" />
                                                        ) : index === 0 ? (
                                                            <MusicNote fontSize="large" />
                                                        ) : (
                                                            <Star fontSize="large" />
                                                        )}
                                                    </Avatar>
                                                </Box>

                                                <Box textAlign="left" ml={2} flexGrow={1} display="flex" flexDirection="column" justifyContent="center" gap={1}>

                                                    <Box display="flex" alignItems="center" gap={1}>
                                                        <Typography variant="h5" fontWeight="bold" color="text.primary">
                                                            {data.text}
                                                        </Typography>

                                                        {/* Tooltip on the right of Title */}
                                                        <Tooltip title={data.tooltipText} arrow placement="right">
                                                            <Info sx={{ fontSize: 20, cursor: "pointer", color: "#6b7280" }} />
                                                        </Tooltip>
                                                    </Box>

                                                    <Typography variant="body2" color="text.secondary" lineHeight={1.6}>
                                                        {data.subText}
                                                    </Typography>
                                                </Box>

                                                {isDisabled ? null : <Box display="flex" justifyContent="center">
                                                    <Radio
                                                        checked={isSelected}
                                                        sx={{
                                                            color: '#d1d5db',
                                                            '&.Mui-checked': {
                                                                color: '#F14950',
                                                            },
                                                        }}
                                                    />
                                                </Box>}
                                            </CardContent>
                                            <CardActions>
                                                {isDisabled && (
                                                    <Alert
                                                        severity="warning"
                                                        sx={{
                                                            width: '100%',
                                                            textAlign: 'left',
                                                            '& .MuiAlert-message': {
                                                                fontSize: '14px'
                                                            }
                                                        }}
                                                    >
                                                        You need {creditLedgerData?.points_required_for_campaign} coins to apply. You have {creditLedgerData?.total_balance} coins.
                                                        <br />
                                                        Review and rate songs to earn more.
                                                    </Alert>
                                                )}
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                );
                            }) : <CircularProgress />}
                        </Grid>

                        {creditLedgerData?.total_balance < creditLedgerData?.points_required_for_campaign && (
                            <Card sx={{
                                background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                                borderRadius: 3,
                                border: '1px solid #f59e0b',
                                mb: 4,
                                mt: 3,
                            }}>
                                <CardContent sx={{ textAlign: 'center', p: 2 }}>
                                    <Typography variant="h5" fontWeight="bold" mb={2}>
                                        Need More Coins?
                                    </Typography>
                                    <Typography variant="body2" mb={3} maxWidth="600px" mx="auto">
                                        Review and rate songs by other artists to earn coins and unlock the Artist Community Campaign.
                                    </Typography>
                                    <Button
                                        className='gn-actionbtn'
                                        variant="contained"
                                        size="large"
                                        onClick={() => {
                                            history.push('/discover-music');
                                        }}
                                    >
                                        Start Reviewing Songs
                                    </Button>
                                </CardContent>
                            </Card>
                        )}
                    </Box>
                );

            case 1:
                return (
                    <Box maxWidth="lg" mx="auto">
                        <Box mb={3}>
                            <SubTabs
                                value={activeTab}
                                onChange={handleTabChange}
                            >
                                <SubTab
                                    value={0}
                                    icon={<MusicNote sx={{ fontSize: 18 }} />}
                                    iconPosition="start"
                                    label={`Your Songs (${musicsTotal})`}
                                />

                                {campaignType === 'reelcampaign' && (
                                    <SubTab
                                        value={1}
                                        icon={<Schedule sx={{ fontSize: 18 }} />}
                                        iconPosition="start"
                                        label={`Unreleased Demos (${demoTotal})`}
                                    />
                                )}
                            </SubTabs>
                        </Box>
                        <Box sx={{ mb: 2 }}>
                            <Box >
                                {/* Search and Filters */}
                                <Box display="flex" gap={2} mb={3} flexWrap="wrap">
                                    <TextField
                                        placeholder="Search songs..."
                                        size="small"
                                        value={activeTab === 0 ? songSearch : demoSearch}
                                        onChange={(e) =>
                                            activeTab === 0 ? setSongSearch(e.target.value) : setDemoSearch(e.target.value)
                                        }
                                        sx={{ flex: 1, minWidth: '200px' }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search />
                                                </InputAdornment>
                                            )
                                        }}
                                    />

                                    <FormControl size="small" sx={{ minWidth: 150 }}>
                                        <Select
                                            // value={genreFilter}
                                            // onChange={(e) => setGenreFilter(e.target.value)}
                                            value={activeTab === 0 ? songGenreFilter : demoGenreFilter}
                                            onChange={(e) =>
                                                activeTab === 0 ? setSongGenreFilter(e.target.value) : setDemoGenreFilter(e.target.value)
                                            }
                                            displayEmpty
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <FilterList />
                                                </InputAdornment>
                                            }
                                        >
                                            <MenuItem value="all">All Genres</MenuItem>
                                            {genreList.map((genre) => (
                                                <MenuItem key={genre.id} value={genre.id}>
                                                    {genre.genre}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    <FormControl size="small">
                                        <Select
                                            value={activeTab === 0 ? songSort : demoSort}
                                            onChange={(e) =>
                                                activeTab === 0
                                                    ? setSongSort(e.target.value)
                                                    : setDemoSort(e.target.value)
                                            }
                                        >
                                            <MenuItem value="all">Sort By</MenuItem>
                                            <MenuItem value="newest">Newest</MenuItem>
                                            <MenuItem value="oldest">Oldest</MenuItem>
                                            <MenuItem value="a-z">A → Z</MenuItem>
                                            <MenuItem value="z-a">Z → A</MenuItem>
                                        </Select>
                                    </FormControl>



                                    <Button
                                        variant="contained"
                                        className="gn-actionbtn"
                                        startIcon={<Add />}
                                        onClick={activeTab === 0 ? RedirectSongPage : RedirectHandleDemo}
                                    >
                                        Add {activeTab === 0 ? 'Songs' : 'Demo Songs'}
                                    </Button>
                                </Box>

                                {/* Tab Content */}
                                {activeTab === 0 && (
                                    <Box>
                                        {songsList.length ? (
                                            songsList.map((song) => (
                                                <Box
                                                    key={song.id}
                                                    sx={{
                                                        mb: 2,
                                                        cursor: 'pointer',
                                                        border: songId?.id === song.id ? '2px solid #F14950' : '0px solid ',
                                                        background: '#fff',
                                                        borderRadius: 2,
                                                    }}
                                                    onClick={() => handleSongSelection(song)}
                                                >
                                                    <CardContent sx={{ p: 2 }}>
                                                        <Box display="flex" alignItems="center" gap={2}>
                                                            <Radio
                                                                checked={songId?.id === song.id}
                                                                onChange={() => handleSongSelection(song)}
                                                                sx={{
                                                                    "& .MuiSvgIcon-root": { fontSize: 18 },
                                                                }}
                                                            />
                                                            <Avatar
                                                                sx={{
                                                                    height: 60,
                                                                    width: 60,
                                                                    borderRadius: 2
                                                                }}
                                                                src={
                                                                    song?.songPoster_url ||
                                                                    (song?.cover_image ? `${process.env.REACT_APP_SONGAPIURL_MEDIA}${song?.cover_image}` : imgThumbnail)
                                                                }
                                                                alt={song.songTitle}
                                                                variant="rounded"
                                                            />

                                                            <Box flex={1}>
                                                                <Typography fontWeight="bold" sx={{ fontSize: '16px' }}>
                                                                    {song.songTitle}
                                                                </Typography>
                                                                {/* <Typography sx={{ fontSize: '12px' }} mb={0.5}>
                                                                    {song.artists || 'Unknown Artist'}
                                                                </Typography> */}

                                                                <Box display="flex" gap={1} mt={1} flexWrap="wrap">
                                                                    {song.genre && (
                                                                        <Chip
                                                                            label={song.genre.genre}
                                                                            size="small"
                                                                            sx={{ bgcolor: '#e3f2fd', p: 1 }}
                                                                        />
                                                                    )}
                                                                    {song.mood && (
                                                                        <Chip
                                                                            label={song.mood.mood}
                                                                            size="small"
                                                                            sx={{ bgcolor: '#fff3e0', p: 1 }}
                                                                        />
                                                                    )}
                                                                    {song.language && (
                                                                        <Chip
                                                                            label={song.language.language}
                                                                            size="small"
                                                                            sx={{ bgcolor: '#f3e5f5', p: 1 }}
                                                                        />
                                                                    )}
                                                                </Box>
                                                            </Box>

                                                            <Box textAlign="right">
                                                                <Typography variant="body2" color="text.secondary" mb={1}>
                                                                    <Schedule fontSize="small" sx={{ verticalAlign: 'middle', mr: 0.5 }} />
                                                                    {new Date(song.created).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
                                                                </Typography>
                                                                <Typography variant="caption" color="text.secondary" display="block" mb={1}>
                                                                    {new Date(song.created).toLocaleDateString('en-US', {
                                                                        month: 'short',
                                                                        day: 'numeric',
                                                                        year: 'numeric'
                                                                    })}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </CardContent>
                                                </Box>
                                            ))
                                        ) : (
                                            <Box textAlign="center" py={4}>
                                                <Typography variant="body1" color="text.secondary">
                                                    No songs found
                                                </Typography>
                                            </Box>
                                        )}

                                        {musicsTotal > 0 && (
                                            <TablePagination
                                                component="div"
                                                count={musicsTotal}
                                                page={musicsPage}
                                                onPageChange={(_, newPage) => fetchUserSong(newPage, musicsLimit)}
                                                rowsPerPage={musicsLimit}
                                                onRowsPerPageChange={(e) => {
                                                    const newLimit = parseInt(e.target.value, 10);
                                                    fetchUserSong(0, newLimit);
                                                }}
                                                rowsPerPageOptions={[5, 10, 25]}
                                            />
                                        )}
                                    </Box>
                                )}

                                {activeTab === 1 && campaignType === 'reelcampaign' && (
                                    <Box>
                                        {demoLoading ? (
                                            <Box display="flex" justifyContent="center" py={4}>
                                                <CircularProgress />
                                            </Box>
                                        ) : demoList.length ? (
                                            demoList.map((demo) => (
                                                <Box
                                                    key={demo.id}
                                                    sx={{
                                                        mb: 2,
                                                        cursor: 'pointer',
                                                        border: selectedDemo?.id === demo.id ? '2px solid #F14950' : '0px solid',
                                                        background: '#fff',
                                                        borderRadius: 2,
                                                    }}
                                                    onClick={() => handleDemoSelection(demo)}
                                                >
                                                    <CardContent sx={{ p: 2 }}>
                                                        <Box display="flex" alignItems="center" gap={2}>
                                                            <Radio
                                                                checked={selectedDemo?.id === demo.id}
                                                                onChange={() => handleDemoSelection(demo)}
                                                                sx={{
                                                                    "& .MuiSvgIcon-root": { fontSize: 18 },
                                                                }}
                                                            />
                                                            <Avatar
                                                                sx={{
                                                                    height: 60,
                                                                    width: 60,
                                                                    borderRadius: 2
                                                                }}
                                                                src={demo.demoPoster_url || imgThumbnail}
                                                                alt={demo.audio_name}
                                                                variant="rounded"
                                                            />

                                                            <Box flex={1}>
                                                                <Typography fontWeight="bold" sx={{ fontSize: '16px' }}>
                                                                    {demo.audio_name}
                                                                </Typography>

                                                                <Box display="flex" gap={1} mt={1} flexWrap="wrap">
                                                                    {demo.genre && (
                                                                        <Chip
                                                                            label={demo.genre.genre}
                                                                            size="small"
                                                                            sx={{ bgcolor: '#e3f2fd' }}
                                                                        />
                                                                    )}
                                                                    {demo.mood && (
                                                                        <Chip
                                                                            label={demo.mood.mood}
                                                                            size="small"
                                                                            sx={{ bgcolor: '#fff3e0' }}
                                                                        />
                                                                    )}
                                                                    {demo.language && (
                                                                        <Chip
                                                                            label={demo.language.language}
                                                                            size="small"
                                                                            sx={{ bgcolor: '#f3e5f5' }}
                                                                        />
                                                                    )}
                                                                </Box>
                                                            </Box>

                                                            <Box textAlign="right">
                                                                <Typography sx={{ fontSize: '12px' }} color="text.secondary" mb={1} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                                                    <Schedule fontSize="small" sx={{ verticalAlign: 'middle', mr: 0.5 }} />
                                                                    {new Date(demo.created).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
                                                                </Typography>
                                                                <Typography sx={{ fontSize: '12px' }} color="text.secondary" display="block" mb={1}>
                                                                    {new Date(demo.created).toLocaleDateString('en-US', {
                                                                        month: 'short',
                                                                        day: 'numeric',
                                                                        year: 'numeric'
                                                                    })}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </CardContent>
                                                </Box>
                                            ))
                                        ) : (
                                            <Box textAlign="center" py={4}>
                                                <Typography variant="body1" color="text.secondary">
                                                    No demos found
                                                </Typography>
                                            </Box>
                                        )}

                                        {demoTotal > 0 && (
                                            <TablePagination
                                                component="div"
                                                count={demoTotal}
                                                page={demoPage}
                                                onPageChange={(_, newPage) => fetchDemoList(newPage, demoLimit)}
                                                rowsPerPage={demoLimit}
                                                onRowsPerPageChange={(e) => {
                                                    const newLimit = parseInt(e.target.value, 10);
                                                    fetchDemoList(0, newLimit);
                                                }}
                                                rowsPerPageOptions={[5, 10, 25]}
                                            />
                                        )}
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>
                );
            case 2:
                return (
                    ((activeStep >= 2 && activeStep <= 4) && campaignType === 'promotion') ?
                        <Card sx={{ height: '50vh', overflow: 'auto' }}>
                            <CardContent>
                                <List>
                                    {stremingPlatformLoader ? (
                                        <SkeletonWaveCard />
                                    ) : !stremingPlatformLoader && stremingPlatform.length ? (
                                        stremingPlatform.map(d => (
                                            <ListItem key={d.id} disablePadding>
                                                <ListItemButton>
                                                    <ListItemAvatar sx={{ minWidth: '40px' }}>
                                                        <Avatar
                                                            sx={{ height: '30px', width: '30px' }}
                                                            alt={d?.platformName}
                                                            src={getStrPlatformImg(d?.streamingPlatformKey)}
                                                        />
                                                    </ListItemAvatar>
                                                    <ListItemText primary={d?.streamingPlatformName} />
                                                    <ListItemIcon>
                                                        <Checkbox
                                                            checked={selectedPlatform.includes(d.streamingPlatform)}
                                                            onChange={(e) => handleCheckboxChange(e, d.streamingPlatform)}
                                                            value={d.streamingPlatform}
                                                            inputProps={{ 'aria-label': d.streamingPlatform }}
                                                        />
                                                    </ListItemIcon>
                                                </ListItemButton>
                                            </ListItem>
                                        ))
                                    ) : (
                                        <NoResults message="No Result Found" />
                                    )}
                                </List>
                            </CardContent>
                        </Card>
                        :
                        <ArtistCampaign songId={songId} selectedDemo={selectedDemo} handleFormChange={handleFormChange} releaseDateChangeHandler={releaseDateChangeHandler} setFormValues={setFormValues} formValues={formValues} stremingPlatform={stremingPlatform} formDateValues={formDateValues} clips={clips} setClips={setClips} songDuration={songDuration} setSongDuration={setSongDuration} setBudgetError={setBudgetError} budgetError={budgetError} setHasInvalidReferenceLink={setHasInvalidReferenceLink} setHasInvalidClipTime={setHasInvalidClipTime} currencyList={currencyList} />
                );
            case 3:
                return (
                    campaignType === 'promotion' ?
                        <Card marginTop={3}>
                            <CardContent>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={12}>
                                        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                            <ListItemAvatar sx={{ width: '80px', height: '80px', marginRight: '10px' }}>
                                                <img alt={songId?.songTitle || '-'} src={songId?.songPoster_url || `${process.env.REACT_APP_SONGAPIURL_MEDIA}${songId.cover_image}` || imgThumbnail} className='w-100 h-100 rounded-1' />
                                            </ListItemAvatar>
                                            {reviewList.map((data, index) => (
                                                <ListItem key={index} alignItems="flex-start" sx={{ paddingTop: '0px', alignItems: 'center' }}>
                                                    <ListItemText
                                                        primary={data?.name || '-'}
                                                        secondary={
                                                            <React.Fragment>
                                                                <Typography component="span" variant="body2" sx={{ color: 'text.primary', display: 'inline' }} />
                                                                {data?.label || '-'}
                                                            </React.Fragment>
                                                        }
                                                    />
                                                </ListItem>))}
                                        </List>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        :
                        <Card marginTop={3}>
                            <CardContent>
                                <BudgetPlan setPackageAmount={setPackageAmount} setActivePlan={setActivePlan} activePlan={activePlan} handleNextStates={() => { }} />
                            </CardContent>
                        </Card>
                );
            default:
                return <Typography>Invalid Step</Typography>;
        }
    };

    const RedirectHandleDemo = () => {
        history.push('/submitdemo');
    }

    const RedirectSongPage = () => {
        history.push('/songhub')
    }

    return (
        <div>
            {userData && userData?.verification_status?.verificationStatus != "Verified" ?
                <PageNotFound />
                :
                <>
                    <Box display="flex" alignItems={'center'} sx={{ cursor: 'pointer' }} p={2}>
                        <IconButton
                            aria-label="back"
                            className='fs-5 gap-2 bg-transparent'
                            onClick={() => {
                                if (hasUnsavedChanges()) {
                                    const confirmLeave = window.confirm("Are you sure you want to leave? Changes you made may not be saved.");
                                    if (confirmLeave) {
                                        window.removeEventListener("beforeunload", handleBeforeUnload);
                                        history.push('/campaign');
                                    }
                                } else {
                                    window.removeEventListener("beforeunload", handleBeforeUnload);
                                    history.push('/campaign');
                                }
                            }}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="body1">Back To Campaign</Typography>
                    </Box>
                    <Box px={5} mb={5} height={'100%'}>
                        <CampaignHeader campaignType={campaignType} activeStep={activeStep} />
                        {renderStepContent()}
                        <Box mt={2} display="flex" justifyContent="space-between">
                            <Button onClick={handlePrevious} disabled={activeStep === 0}>Previous</Button>
                            <Button className='gn-actionbtn' onClick={handleNext} disabled={isSubmitting || (location?.campaignDetail?.id ? false : nextDisable)}>
                                {isSubmitting ? (
                                    <CircularProgress size={22} sx={{ color: '#fff' }} />
                                ) : (
                                    activeBtnText
                                )}
                            </Button>
                        </Box>
                    </Box>
                </>
            }
        </div>
    );
}
